import {getDropDownFactory} from "../../../components/fieldEditors/editorFactories.js";
import SessionHandler from "../../../SessionHandler.js";

/**
 * Searchable dropdown of existing usernames, for string fields holding a username (e.g. App.owner).
 * Superadmin only, since the full user list is only visible to superadmins; for anyone else the
 * list is empty (the backend rejects non-superadmins for these fields anyway).
 *
 * HeweconUserForAdmin is imported lazily because it imports UserRole, which imports App, so a static
 * import from the models that use this would be circular.
 */
export default getDropDownFactory({
    optionsLoader: (searchString) => {
        if (!SessionHandler.isSuperAdmin()) {
            return Promise.resolve([]);
        }
        return import("../admin/HeweconUserForAdmin.js").then(({default: HeweconUserForAdmin}) =>
            HeweconUserForAdmin.getListForDropdown(searchString, [HeweconUserForAdmin.username]))
            .then(users => users.map(user => user.username));
    }
});
